import { eventHandlers as menuHandlers } from './menu/event-handlers';
import * as menuDispatchers from './menu/dispatchers';
import { eventHandlers as productDetailsHandlers } from './product-details/event-handlers';
import * as productDetailsDispatchers from './product-details/dispatchers';
import { eventHandlers as productListHandlers } from './product-list/event-handlers';
import * as productListDispatchers from './product-list/dispatchers';
import { eventHandlers as productBundleDetailsHandlers } from './product-bundle-details/event-handlers';
import * as productBundleDetailsDispatchers from './product-bundle-details/dispatchers';
import { eventHandlers as shoppingCartHandlers } from './shopping-cart/event-handlers';
import * as shoppingCartDispatchers from './shopping-cart/dispatchers';
import { eventHandlers as shoppingCartEmptyHandlers } from './shopping-cart-empty/event-handlers';
import * as shoppingCartEmptyDispatchers from './shopping-cart-empty/dispatchers';
import { eventHandlers as productSearchStartHandlers } from './product-search-start/event-handlers';
import * as productSearchStartDispatchers from './product-search-start/dispatchers';
import { eventHandlers as productSearchResultsHandlers } from './product-search-results/event-handlers';
import * as productSearchResultsDispatchers from './product-search-results/dispatchers';
import { eventHandlers as checkoutShippingMethodHandlers } from './checkout-shipping-method/event-handlers';
import * as checkoutShippingMethodDispatchers from './checkout-shipping-method/dispatchers';
import { eventHandlers as checkoutHostedPaymentMethodHandlers } from './checkout-hosted-payment-method/event-handlers';
import * as checkoutHostedPaymentMethodDispatchers from './checkout-hosted-payment-method/dispatchers';

interface CreateEventParams {
	eventType: string;
	data?: unknown;
	context?: unknown;
}

const EVENT_HANDLERS: Record<string, string | ((data: unknown) => string)> = {
	...menuHandlers,
	...productDetailsHandlers,
	...productListHandlers,
	...productBundleDetailsHandlers,
	...shoppingCartHandlers,
	...shoppingCartEmptyHandlers,
	...productSearchStartHandlers,
	...productSearchResultsHandlers,
	...checkoutShippingMethodHandlers,
	...checkoutHostedPaymentMethodHandlers,
};

const DISPATCHERS: Record<string, (params: { data?: unknown; context?: unknown }) => unknown | null> = {
	...menuDispatchers,
	...productDetailsDispatchers,
	...productListDispatchers,
	...productBundleDetailsDispatchers,
	...shoppingCartDispatchers,
	...shoppingCartEmptyDispatchers,
	...productSearchStartDispatchers,
	...productSearchResultsDispatchers,
	...checkoutShippingMethodDispatchers,
	...checkoutHostedPaymentMethodDispatchers,
};

export const createEvent = ({ eventType, data, context }: CreateEventParams): unknown | null => {
	const route = EVENT_HANDLERS[eventType];
	const key = route
		? typeof route === 'function'
			? route(data)
			: route
		: eventType;
	return DISPATCHERS[key]?.({ data, context }) ?? null;
};

export const getRegisteredEventTypes = (): string[] => Object.keys(EVENT_HANDLERS);
